import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=0cf5c6fc&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=0cf5c6fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5c6fc",
  null
  
)

export default component.exports